import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Button } from 'src/components/Button';
import { Card } from 'src/components/Card';
import {
  ConfirmDialog,
  useConfirmDialogComponent,
} from 'src/components/ConfirmDialog';
import { Icon } from 'src/components/Icon';
import toast from 'src/utils/toast';

import { AssessmentFormValues } from '../AssessmentNewPage';

import { AssessmentRule } from './AssessmentRule';

export const AssessmentRules = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'assessment.rules',
  });
  const { values, setFieldValue } = useFormikContext<AssessmentFormValues>();
  const [confirmDialogProps, confirm] = useConfirmDialogComponent();

  const handleAddRule = () => {
    const currentRules = values.rules || [];
    const newRule = {
      name: t('newRule'),
      formulas: [],
    };
    setFieldValue('rules', [...currentRules, newRule]);
  };

  const handleRemoveRule = async (_rule: any) => {
    return await confirm({
      title: t('confirmDelete'),
      message: t('confirmDeleteMessage'),
    });
  };

  const handleCloneRule = (rule: any) => {
    const clonedRule = JSON.parse(JSON.stringify(rule));
    clonedRule.name = rule.name + ' ' + t('copy');

    // Deep clone formulas if they exist
    if (clonedRule.formulas) {
      clonedRule.formulas = clonedRule.formulas.map((f: any) => {
        const formula = { ...f };
        if (formula.lhs) {
          formula.lhs = formula.lhs.map((o: any) => ({ ...o }));
        }
        return formula;
      });
    }

    // Deep clone result if it exists
    if (clonedRule.result) {
      clonedRule.result = { ...clonedRule.result };
    }

    const currentRules = values.rules || [];
    setFieldValue('rules', [...currentRules, clonedRule]);
    toast.success(`${rule.name} successfully cloned.`);
  };

  const rules = values.rules || [];

  return (
    <>
      <Box>
        {rules.map((rule: any, index: number) => (
          <Card key={index} sx={{ p: 2, mb: 2 }}>
            <AssessmentRule
              rule={rule}
              onRemove={handleRemoveRule}
              onClone={handleCloneRule}
              index={index}
            />
          </Card>
        ))}
        <Box>
          <Button variant="prominent" onClick={handleAddRule}>
            <Icon icon={faPlus} sx={{ mr: 1 }} />
            {t('addRule')}
          </Button>
        </Box>
      </Box>
      <ConfirmDialog {...confirmDialogProps} />
    </>
  );
};
